import React from 'react';

import Banner from '../../../../../../common/components/indicators/banner/Banner';

const InsufficientPermissionsBanner: React.FC = () => {
  return (
    <Banner variant="information">
      <Banner.Title>You do not have permission to create or update indications.</Banner.Title>
    </Banner>
  );
};

export default InsufficientPermissionsBanner;
